import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export const CustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
  <div className="date-range-picker" onClick={onClick} ref={ref}>
    {value || <span style={{ opacity: 0.7, margin: "0 1em" }}>--</span>}
  </div>
));

CustomDateInput.displayName = "CustomDateInput";

export default class FromToDatePickerInput extends React.Component {
  /*
      * props:
      *
      * handleDateChange, //req // (from, to) => {}
              ** NOTE THAT ONE CHANGE MIGHT CHANGE BOTH DATES. STATE MUST BE RESET EACH TIME FOR BOTH DATES IN handleDateChange

      * minDate (Date Object)
      * maxDate (DateObject)
      * from (DateObject) (actual value) //req
      * to (DateObject) (actual value) //req


  * */

  handleFromDateChange = (date) => {
    let to = this.props.to;
    if (date > to || !to) to = date;
    this.props.handleDateChange(date, to);
  };

  handleToDateChange = (date) => {
    let from = this.props.from;
    if (date < from || !from) from = date;
    this.props.handleDateChange(from, date);
  };

  render() {
    let { value, onClick } = this.props;
    return (
      <React.Fragment>
        {this.props.showTitle && (
          <div className="box-select-title">Date Range</div>
        )}
        <div className="date-input-button-wrapper">
          <DatePicker
            selected={this.props.from}
            startDate={this.props.from}
            endDate={this.props.to}
            selectsStart
            onChange={this.handleFromDateChange}
            minDate={this.props.minDate || new Date(2020, 0, 20)}
            todayButton="Today"
            customInput={<CustomDateInput />}
          />
          <div className="dash-divider" />
          <DatePicker
            selected={this.props.to}
            startDate={this.props.from}
            endDate={this.props.to}
            selectsEnd
            onChange={this.handleToDateChange}
            maxDate={this.props.maxDate || new Date()}
            todayButton="Today"
            customInput={<CustomDateInput />}
          />
        </div>
      </React.Fragment>
    );
  }
}
